import { trackViewContent } from "@/events/evolutionsMixpanel";
import { storeSignupContext } from "@/events/signupTracking";
import { getVersionAssetsSelector } from "@/redux/loadedContent/loadedContentSlice";
import { userIsLoggedInSelector } from "@/redux/user/userSlice";
import { useSelector } from "react-redux";
import { NavLink } from "react-router";

import { APIStatus } from "../../../api/APIStatus.type";
import {
  MetaRatingsPlayer,
  generateNavigationUrl,
  versionUrlSlug,
} from "../../../redux/players/playersSlice";
import { MyEvolutionsEmptyState } from "./MyEvolutionsEmptyState";
import { PlayerGridCard } from "./PlayerGridCard";
import { PLAYERS_GRID_CLASS } from "./PlayersList";

type Props = {
  players: MetaRatingsPlayer[];
  status: APIStatus;
};

/** The players list's grid, for the user's own evolved players. */
export const MyEvolvedPlayersList = ({ players, status }: Props) => {
  const versionAssets = useSelector(getVersionAssetsSelector);
  const isLoggedIn = useSelector(userIsLoggedInSelector);

  if (!isLoggedIn || status === "rejected" || players.length === 0) {
    return (
      <MyEvolutionsEmptyState
        section="Evolutions"
        status={status}
        onCreateAccountClick={() =>
          storeSignupContext("cta", {
            section: "Evolutions",
            subsection: "My Evolutions",
          })
        }
      />
    );
  }

  return (
    <div className="@container w-full">
      <div className={PLAYERS_GRID_CLASS}>
        {players.map((p) => (
          <NavLink
            key={p.evoPathId + (p.evolutionPath?.join("") ?? "")}
            to={generateNavigationUrl({
              evoPathId: p.evoPathId,
              name: p.name,
              resourceId: p.resourceId,
              canEvolve: p.canEvolve,
              evolutionPath: p.evolutionPath,
              pathwayPath: p.pathwayPath,
              versionSlug: versionUrlSlug(versionAssets[p.versionId]),
              basePath: "/evolutions/players",
            })}
            draggable="false"
            onClick={() =>
              trackViewContent({
                subsection: "My Evolutions",
                content_type: "evo_player",
                action_type: "core",
                new_content: false,
              })
            }
          >
            <PlayerGridCard player={p} show3Chem={false} />
          </NavLink>
        ))}
      </div>
    </div>
  );
};
